import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar          from './components/Navbar.jsx';
import Dashboard       from './pages/Dashboard.jsx';
import WorkflowEditor  from './pages/WorkflowEditor.jsx';
import WorkflowRuns    from './pages/WorkflowRuns.jsx';

export default function App() {
  return (
    <BrowserRouter>
      <div className="h-full flex flex-col">
        <Navbar />
        <main className="flex-1 overflow-hidden">
          <Routes>
            <Route path="/"                           element={<Dashboard />} />
            <Route path="/workflows/new"              element={<WorkflowEditor />} />
            <Route path="/workflows/:id"              element={<WorkflowEditor />} />
            <Route path="/workflows/:id/runs"         element={<WorkflowRuns />} />
            <Route path="*"                           element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}
